import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/auth';
import 'firebase/messaging'
import 'firebase/analytics'

import { firebaseConfig, vapiKey} from './private/firebaseConfig'

const MyFirebase = {
  install(Vue) {
    // 親の顔より見た初期化
    if(!firebase.apps.length){
      firebase.initializeApp(firebaseConfig)
    }
    const isSupported = firebase.messaging.isSupported()

    // FCM対応かつsafariでない場合のみ有効化
    const messaging = isSupported ?firebase.messaging(): null
    const analytics = firebase.analytics()

    // どこでも呼び出し可能にする
    Vue.prototype.$firebase = firebase
    Vue.prototype.$auth = firebase.auth()
    Vue.prototype.$db = firebase.firestore()
    Vue.prototype.$functions = firebase.functions()
    Vue.prototype.$fieldValue = firebase.firestore.FieldValue
    Vue.prototype.$analytics = analytics
    Vue.prototype.$messaging = messaging
    Vue.prototype.$vapiKey = vapiKey
  }
}

export { MyFirebase }